import NamedDto from 'modules/base/dto/NamedDto';

export class EdtDynamicCheckLogEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _EdtDynamicCheckLogEditDtoProps
	 * @property {string} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _EdtDynamicCheckLogEditDtoProps} EdtDynamicCheckLogEditDtoProps
	 */
	/**
	 *
	 * @param {EdtDynamicCheckLogEditDtoProps} props
	 * @returns {EdtDynamicCheckLogEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.userGroup = props.userGroup;

		return this;
	}
}

export default EdtDynamicCheckLogEditDto;
